jQuery(function($) {
  $(document).on('click', 'a[href="#AirReviews-BlockWrapper"]', function(e) {
    e.preventDefault();

    // Perform a click on the 5th tab
    var $targetTab = $('ul.nav.nav-tabs.ss li:nth-child(5)');
    $targetTab.find('a, button').first().trigger('click');

    // Smooth scroll down to that tab
    $('html, body').animate({
      scrollTop: $targetTab.offset().top - 50 // adjust offset if needed
    }, 600);
  });
});




function initRelatedBlogSlider(){
  var $el = $('#related-blog-slider');
  if(!$el.length) return;
  if($el.hasClass('slick-initialized')) $el.slick('unslick');

  $el.slick({
    slidesToShow: parseInt($el.data('items')) || 3,
    slidesToScroll: 1,
    infinite: String($el.data('loop')) === 'true',
    arrows: String($el.data('nav')) === 'true',
    dots:   String($el.data('dots')) === 'true',
    autoplay: String($el.data('autoplay')) === 'true',
    autoplaySpeed: parseInt($el.data('autoplaytimeout')) || 6000,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: parseInt($el.data('items_lg')) || 4 } },
      { breakpoint: 992,  settings: { slidesToShow: parseInt($el.data('items_md')) || 4 } },
      { breakpoint: 768,  settings: { slidesToShow: parseInt($el.data('items_sm')) || 2 } },
      { breakpoint: 576,  settings: { slidesToShow: parseInt($el.data('items_xs')) || 1 } }
    ]
  });
}

document.addEventListener('DOMContentLoaded', initRelatedBlogSlider);
document.addEventListener('shopify:section:load', initRelatedBlogSlider);




$(document).on("click", 'a[href="#AirReviews-BlockWrapper"]', function (e) {
  e.preventDefault();

  // Perform the tab click
  const $targetTab = $("ul.nav.nav-tabs.ss li:nth-child(4) a");
  if ($targetTab.length) {
    $targetTab.trigger("click");

    // Smooth scroll to the tab element
    $("html, body").animate(
      {
        scrollTop: $targetTab.offset().top - 100 // adjust offset if you need spacing
      },
      600 // duration in ms
    );
  }
});

$(document).on("click touchend", ".nov-close, .sidebar-overlay, .cart-close, .drawer-close", function() {
  setTimeout(function() {
    $("body").removeClass("cart_popup_opened");
  }, 550);
});

